import Swiper, { Autoplay, Lazy, Navigation, Pagination } from 'swiper';
Swiper.use([Autoplay, Lazy, Navigation, Pagination]);
window.Swiper = Swiper;

import LoadPurchase from './common/loadPurchase.js';
import CartDrawer from './common/cartDrawer';
import Footer from './common/footer';
import Header from './common/header';
import Webforms from './common/webforms';
import { NewsletterComponent, PriceComponent } from './components/vndaComponents.js';
import { setSearch } from './components/utilities';
import TopBar from './common/topBar.js';
import Language from './components/language.js';
 
let threshold = 300;
if (window.innerWidth < 768) threshold = 100;

window.lazyLoadOptions = {
  elements_selector: '.lazy',
  threshold,
};

window.addEventListener(
  'LazyLoad::Initialized',
  (event) => {
    window.lazyLoadInstance = event.detail.instance;
  },
  { passive: true }
);

// ==========================================
// Inicialização
// ==========================================
console.log(
  '%cVnda - Tecnologia em Ecommerce',
  'color: #f88d5b; font-size: 15px; font-family: "Verdana", sans-serif; font-weight: bold;'
);

window.addEventListener('DOMContentLoaded', () => {
  TopBar.init();
  Header.init();
  Language.init();
  LoadPurchase.init();
  PriceComponent.init();
  CartDrawer.init();
  Footer.init();
  Webforms.init();
  NewsletterComponent.init();
  setSearch();
});
